import(/* webpackMode: "eager" */ "C:\\Users\\piete\\Documents\\Work\\Websites\\call-a-doctor-website 2\\call-a-doctor-website\\src\\app\\blog\\page.tsx");
